import api from './api';

// Talks to /api/distribution/* — operational drivers, variable running costs,
// and the cross-site expense catalogue behind them. Version and site come from
// the x-budget-version-id / x-site-code headers (set by the api interceptor),
// so nothing here passes them explicitly.
//
// `module` defaults to MOD_4_MOVE on the server; pass it when another module
// (Manufacturing variable overheads, say) reuses these tables.
export const distributionService = {
  // ---- Operational drivers (per site) --------------------------------------
  // { lines, values, catalogue, uoms, productClasses, stockGroups }
  getDrivers: async () => {
    const res = await api.get('/distribution/drivers');
    return res.data;
  },

  // payload: { driver_code, value_source?, volume_uom?, volume_filter?,
  //            conversion_factor?, notes? }
  addDriver: async (payload) => {
    const res = await api.post('/distribution/drivers', payload);
    return res.data;
  },

  // payload: { lines: [...], values: [...] }
  saveDrivers: async (payload) => {
    const res = await api.put('/distribution/drivers', payload);
    return res.data;
  },

  deleteDriver: async (driverLineId) => {
    const res = await api.delete('/distribution/drivers', { data: { driver_line_id: driverLineId } });
    return res.data;
  },

  // ---- Variable running costs (per site) -----------------------------------
  // { lines, catalogue, driverValues, drivers, costCenters, accounts }
  getVariableCosts: async (module) => {
    const res = await api.get('/distribution/variable-costs', { params: module ? { module } : undefined });
    return res.data;
  },

  addVariableCostLine: async (lineCode, module) => {
    const res = await api.post('/distribution/variable-costs', { line_code: lineCode, module_code: module });
    return res.data;
  },

  // payload: { lines: [...], rates: [...] }
  saveVariableCosts: async (payload) => {
    const res = await api.put('/distribution/variable-costs', payload);
    return res.data;
  },

  deleteVariableCostLine: async (expenseSiteId) => {
    const res = await api.delete('/distribution/variable-costs', { data: { expense_site_id: expenseSiteId } });
    return res.data;
  },

  // ---- Expense catalogue (Budget Setup, cross-site) ------------------------
  // { lines, drivers, accounts, costCenters }
  getExpenseCatalogue: async (module) => {
    const res = await api.get('/distribution/expense-catalogue', { params: module ? { module } : undefined });
    return res.data;
  },

  // payload: { lines: [...], module_code? }
  saveExpenseCatalogue: async (payload) => {
    const res = await api.put('/distribution/expense-catalogue', payload);
    return res.data;
  },

  // `force` deletes even when sites have taken the line up (their rates go too).
  deleteExpenseCatalogueLine: async (lineCode, { module, force } = {}) => {
    const res = await api.delete('/distribution/expense-catalogue', {
      data: { line_code: lineCode, module_code: module, force: !!force },
    });
    return res.data;
  },
};

export default distributionService;
